

const dashboardModule = angular.module('dashboard',[]);

export default dashboardModule;